// extracted by mini-css-extract-plugin
export var blurb = "blurb-module--blurb--X5110";